import tablelistApi from 'api/tablelistApi'

export default {
  listByBookingId(bookingId, options = {}) {
    if (!bookingId) throw new Error('bookingId')

    return tablelistApi.get(`/booking/${bookingId}/ticket`, options)
  },
  listByOrderAndVenueId(orderId, venueId, options = {}) {
    if (!orderId) throw new Error('orderId')
    if (!venueId) throw new Error('venueId')

    return tablelistApi.get(`/v1/venues/${venueId}/orders/${orderId}/tickets`, options)
  },
}



// WEBPACK FOOTER //
// ./src/api/ticket/service.js